/** @jsx jsx */
import { Button, Grid, IconButton } from "@cd2/components/build/es6"
import { Fields, Form2 } from "@cd2/forms/build/es6"
import { P } from "@cd2/text/build/es6"
import { css, jsx } from "@emotion/core"
import { useState } from "react"
import { icons } from "../../constants/icons"

/** Branch settings list of the sites a payment can be taken at, e.g. Dublin and Cork. */
export function PaymentLocationsField({ field }: { field: string }) {
  const [newLocation, setNewLocation] = useState("")
  const [error, setError] = useState<string>()
  const locationsField = Form2.useField<string[]>(field, { subscribe: true, defaultValue: [] })
  const locations = locationsField.getValue() ?? []

  Form2.useFormSubmitLock(() => {
    const names = locations.map(l => l.trim().toLowerCase())
    if (names.some(name => !name)) {
      locationsField.setError("Locations must have a name. Change or remove the empty rows.")
      return false
    }
    if (new Set(names).size !== names.length) {
      locationsField.setError("Locations must be unique. Change or remove duplicate rows.")
      return false
    }
    locationsField.setError(undefined)
  })

  function handleAdd() {
    const value = newLocation.trim()
    if (!value) {
      setError("must enter a location")
      return
    }
    if (locations.some(l => l.trim().toLowerCase() === value.toLowerCase())) {
      setError("location already exists")
      return
    }
    setError(undefined)
    setNewLocation("")
    locationsField.setValue([...locations, value])
  }

  return (
    <Grid
      gap={12}
      css={css`
        width: 100%;
      `}
    >
      <P blockSpacing={0}>
        For branches covering more than one site. When set, the location a payment was taken at must
        be picked on orders and when logging a customer payment. Leave empty for no change.
      </P>
      {locationsField.getError() && <P color="error">{locationsField.getError()}</P>}
      {locations.map((location, i) => (
        <Grid key={i} columns={[{ fr: 1 }, "max-content"]} gap={8}>
          <Fields.Text
            placeholder="Location"
            value={location}
            onChange={value =>
              locationsField.setValue(locations.map((l, index) => (index === i ? value : l)))
            }
          />
          <IconButton
            buttonStyle="text"
            icon={icons.cross}
            buttonColor="white"
            onClick={() => locationsField.setValue(locations.filter((_, index) => index !== i))}
            square
          />
        </Grid>
      ))}
      <Grid columns={[{ fr: 1 }, "max-content"]} gap={8}>
        <div
          onKeyDown={event => {
            if (event.key === "Enter") {
              event.preventDefault()
              event.stopPropagation()
              handleAdd()
            }
          }}
        >
          <Fields.Text
            placeholder="Add a location, e.g. Dublin"
            value={newLocation}
            onChange={setNewLocation}
            error={error}
          />
        </div>
        <Button onClick={handleAdd} buttonStyle="outline" buttonColor="#333">
          + Add
        </Button>
      </Grid>
    </Grid>
  )
}
